import api from '@/api';

const store = {
  state: {},

  mutations: {},

  getters: {},

  actions: {
    async customerUploadAction({ commit }, payload) {
      try {
        const { data } = await api.customerUpload(payload);
        return data;
      } catch (e) {
        return e;
      }
    }
  }
};

export default store;
